import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss']
})
export class LoaderComponent {

}
